<template>
  <div>
    <child :showButton="showButton"></child>
  </div>
</template>

<script>
import docuAbout from '@/views/component/docuCommon/docuAbout';
export default {
  name: 'MdopEditAbout',
  components: {
    child: docuAbout
  },
  props: {
    showButton: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped></style>
